module.exports = __webpack_public_path__ + "img/arms.f277d419.png";